import { useEffect, useMemo } from "react";

import { OrderFields } from "../../constants";
import useOrderData from "../../context/useOrderData";
import useOrderFormik from "../useOrderFormik";

const useUpdateOfferGroupId = (): void => {
  const {
    values: { [OrderFields.DELIVERY_METHOD]: deliveryMethod },
    setFieldValue,
  } = useOrderFormik();

  const {
    dynamicData: { offers },
  } = useOrderData();

  const offerGroupId = useMemo(
    () =>
      offers.find(({ deliveryMethod: offerDeliveryMethod }) => offerDeliveryMethod === deliveryMethod)?.priceGroupId,
    [deliveryMethod, offers]
  );

  useEffect(() => {
    setFieldValue(OrderFields.OFFER_GROUP_ID, offerGroupId);
  }, [offerGroupId, setFieldValue]);
};
export default useUpdateOfferGroupId;
